const getPractitionerWithoutPractice = (
  firstName: string,
  lastName: string,
  practitionerId: string
) => ({
  label: `${firstName} ${lastName}`,
  value: practitionerId,
});

export const getPractitionerSelectOptions = (data: any) => {
  const { practitioners } = data;
  const { edges } = practitioners;

  return edges
    .map(({ node }: any) => {
      const { firstName, lastName, id: practitionerId, locations } = node;

      if (locations?.edges?.length > 0) {
        return locations.edges.map(({ node: practiceNode }: any) =>
          practiceNode?.practice
            ? {
                label: `${firstName} ${lastName} (${practiceNode?.practice?.practiceName}/${practiceNode?.locationName})`,
                value: `${practitionerId}|${practiceNode?.id}`,
              }
            : getPractitionerWithoutPractice(firstName, lastName, practitionerId)
        );
      }

      return getPractitionerWithoutPractice(firstName, lastName, practitionerId);
    })
    .flat();
};
